/* =========================================================
   COSTA SNEAKERS — motor del theme
   Carrito ajax · ficha en modal · hoja de tallas · drawers
   Sin dependencias.
   ========================================================= */
(function () {
  'use strict';

  var C = window.Costa || {};
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var ESCRITORIO = function () { return window.matchMedia('(min-width: 990px)').matches; };

  /* ---------------------------------------------------------
     1. Capas (velo, drawers, hojas, modal)
     --------------------------------------------------------- */
  var velo = $('[data-velo]');
  var capaActiva = null;
  var ultimoFoco = null;

  function abrirCapa(nombre) {
    var capa = $('[data-capa="' + nombre + '"]');
    if (!capa) return null;
    if (capaActiva && capaActiva !== capa) cerrarCapa({ silencioso: true });
    ultimoFoco = document.activeElement;
    capa.setAttribute('data-abierto', '');
    if (velo) { velo.removeAttribute('hidden'); velo.setAttribute('data-abierto', ''); }
    document.body.setAttribute('data-bloqueado', '');
    capaActiva = capa;
    var enfocable = capa.querySelector('[data-cerrar-capa], button, a[href], input');
    if (enfocable) { try { enfocable.focus({ preventScroll: true }); } catch (e) {} }
    return capa;
  }

  function cerrarCapa(opts) {
    opts = opts || {};
    if (!capaActiva) return;
    var eraFicha = capaActiva.getAttribute('data-capa').indexOf('ficha') === 0;
    capaActiva.removeAttribute('data-abierto');
    capaActiva = null;
    if (velo) { velo.removeAttribute('data-abierto'); }
    document.body.removeAttribute('data-bloqueado');
    if (ultimoFoco && !opts.silencioso) { try { ultimoFoco.focus({ preventScroll: true }); } catch (e) {} }
    if (eraFicha && !opts.silencioso && !opts.desdeHistorial) restaurarUrl();
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cerrar-capa]')) { e.preventDefault(); cerrarCapa(); return; }
    if (velo && e.target === velo) { cerrarCapa(); return; }
    var disparador = e.target.closest('[data-abrir]');
    if (disparador) { e.preventDefault(); abrirCapa(disparador.getAttribute('data-abrir')); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && capaActiva) { e.preventDefault(); cerrarCapa(); return; }
    if (e.key !== 'Tab' || !capaActiva) return;
    var foco = $$('a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])', capaActiva)
      .filter(function (n) { return n.offsetParent !== null; });
    if (!foco.length) return;
    var primero = foco[0], ultimo = foco[foco.length - 1];
    if (e.shiftKey && document.activeElement === primero) { e.preventDefault(); ultimo.focus(); }
    else if (!e.shiftKey && document.activeElement === ultimo) { e.preventDefault(); primero.focus(); }
  });

  /* ---------------------------------------------------------
     1b. Desplegables del menú de escritorio (Ropa, Marcas)
     Con mouse abren por :hover (CSS). El clic los fija abiertos, que es lo que
     sirve en tablet y con teclado; se cierran con otro clic, Escape o clic fuera.
     --------------------------------------------------------- */
  function cerrarGrupos(excepto) {
    $$('[data-nav-grupo][data-abierto]').forEach(function (g) {
      if (g === excepto) return;
      g.removeAttribute('data-abierto');
      var btn = g.querySelector('button');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-nav-grupo] > button');
    if (btn) {
      var grupo = btn.parentNode;
      var abrir = !grupo.hasAttribute('data-abierto');
      cerrarGrupos(grupo);
      if (abrir) grupo.setAttribute('data-abierto', ''); else grupo.removeAttribute('data-abierto');
      btn.setAttribute('aria-expanded', abrir ? 'true' : 'false');
      return;
    }
    if (!e.target.closest('[data-nav-grupo]')) cerrarGrupos();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var abierto = $('[data-nav-grupo][data-abierto]');
    if (!abierto) return;
    cerrarGrupos();
    var btn = abierto.querySelector('button');
    if (btn) btn.focus();
  });

  /* ---------------------------------------------------------
     1c. Filtros de colección
     Antes ningún código enviaba el formulario: marcar una casilla no hacía nada.
     Se arma la URL a mano para no mandar campos vacíos (un precio vacío rompe el
     filtro) y para volver siempre a la página 1.
     --------------------------------------------------------- */
  function urlFiltros(form) {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (valor, clave) {
      if (String(valor).trim() !== '') params.append(clave, valor);
    });
    var q = params.toString();
    var base = form.getAttribute('action') || window.location.pathname;
    return base + (q ? '?' + q : '');
  }
  document.addEventListener('change', function (e) {
    var form = e.target.closest('[data-filtros]');
    if (!form || form.hasAttribute('data-filtros-manual')) return;
    if (e.target.type === 'number') return; // el precio se aplica con su botón o Enter
    window.location.href = urlFiltros(form);
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-filtros]');
    if (!form) return;
    e.preventDefault();
    window.location.href = urlFiltros(form);
  });

  /* ---------------------------------------------------------
     2. Aviso flotante
     --------------------------------------------------------- */
  var toast = $('[data-toast]'), toastTimer;
  function avisar(texto, esError) {
    if (!toast) return;
    toast.innerHTML = '';
    if (!esError) {
      var ok = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      ok.setAttribute('viewBox', '0 0 24 24'); ok.setAttribute('fill', 'none');
      ok.setAttribute('stroke', 'currentColor'); ok.setAttribute('stroke-width', '3');
      ok.setAttribute('stroke-linecap', 'round'); ok.setAttribute('stroke-linejoin', 'round');
      var p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      p.setAttribute('d', 'M5 12.5l4.5 4.5L19 7'); ok.appendChild(p); toast.appendChild(ok);
    }
    var span = document.createElement('span'); span.textContent = texto; toast.appendChild(span);
    toast.setAttribute('data-abierto', '');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.removeAttribute('data-abierto'); }, 2800);
  }

  /* ---------------------------------------------------------
     3. Carrito
     --------------------------------------------------------- */
  function actualizarContadores(n) {
    $$('[data-contador-carrito]').forEach(function (el) {
      el.textContent = n;
      if (n > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
  }

  function refrescarCarrito() {
    return fetch(window.location.pathname + '?section_id=carrito-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var destino = $('[data-carrito-contenido]');
        if (destino) destino.innerHTML = html;
        return fetch(C.rutas.carrito + '.js', { headers: { 'Accept': 'application/json' } });
      })
      .then(function (r) { return r.json(); })
      .then(function (carrito) { actualizarContadores(carrito.item_count); return carrito; })
      .catch(function () {});
  }

  function agregarAlCarrito(idVariante, cantidad, boton) {
    if (!idVariante) { avisar(C.textos.seleccionaTalla, true); return Promise.resolve(); }
    if (boton) boton.setAttribute('aria-busy', 'true');
    return fetch(C.rutas.carritoAgregar, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(idVariante), quantity: cantidad || 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () { return refrescarCarrito(); })
      .then(function () {
        avisar(C.textos.agregado);
        cerrarCapa({ silencioso: true });
        abrirCapa('carrito');
      })
      .catch(function () { avisar(C.textos.error, true); })
      .then(function () { if (boton) boton.removeAttribute('aria-busy'); });
    }

  function cambiarLinea(clave, cantidad) {
    return fetch(C.rutas.carritoCambiar, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: clave, quantity: cantidad })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refrescarCarrito(); })
      .catch(function () { avisar(C.textos.error, true); });
  }

  document.addEventListener('click', function (e) {
    var paso = e.target.closest('[data-qty]');
    if (paso) {
      var linea = paso.closest('[data-linea]');
      var salida = linea.querySelector('output');
      var nueva = parseInt(salida.textContent, 10) + parseInt(paso.getAttribute('data-qty'), 10);
      if (nueva < 0) nueva = 0;
      linea.setAttribute('aria-busy', 'true');
      cambiarLinea(linea.getAttribute('data-clave'), nueva);
      return;
    }
    var quitar = e.target.closest('[data-quitar]');
    if (quitar) {
      var l = quitar.closest('[data-linea]');
      l.setAttribute('aria-busy', 'true');
      cambiarLinea(l.getAttribute('data-clave'), 0);
    }
  });

  /* ---------------------------------------------------------
     4. Selección de talla (dentro de ficha u hoja)
     --------------------------------------------------------- */
  function datosDe(contenedor) {
    var script = contenedor.querySelector('[data-ficha-json]');
    if (!script) return null;
    try { return JSON.parse(script.textContent); } catch (e) { return null; }
  }

  function pintarVariante(ambito, variante) {
    var precio = ambito.querySelector('[data-precio]');
    if (precio && variante.precio_texto) precio.textContent = variante.precio_texto;

    var boton = ambito.querySelector('[data-agregar]');
    if (boton) {
      boton.setAttribute('data-variante', variante.id);
      boton.textContent = C.textos.agregar + ' · ' + variante.precio_texto;
    }

    var stock = ambito.querySelector('[data-stock]');
    if (stock) {
      var mostrar = C.mostrarStock && variante.inventario > 0 && variante.inventario <= (C.umbralStock || 4);
      if (mostrar) {
        stock.querySelector('span').textContent =
          (C.textos.ultimasUnidades || '').replace('__N__', variante.inventario).replace('__T__', variante.titulo);
        stock.removeAttribute('hidden');
      } else {
        stock.setAttribute('hidden', '');
      }
    }
  }

  /* Un producto puede tener varias opciones (Talla, Color). Cada fila elige un
     valor; la variante es la que coincide con todos los valores elegidos. */
  function gruposDe(ambito) { return $$('[data-grupo-opcion]', ambito); }

  function seleccionDe(ambito) {
    var vals = [];
    gruposDe(ambito).forEach(function (g) {
      var sel = g.querySelector('.talla[aria-pressed="true"]');
      vals[Number(g.getAttribute('data-indice'))] = sel ? sel.getAttribute('data-valor') : null;
    });
    return vals;
  }

  function casa(variante, vals) {
    var ops = variante.opciones || [];
    for (var i = 0; i < vals.length; i++) {
      if (vals[i] != null && ops[i] !== vals[i]) return false;
    }
    return true;
  }

  function buscarVariante(datos, vals, soloDisponibles) {
    if (!datos || !datos.variantes) return null;
    for (var i = 0; i < datos.variantes.length; i++) {
      var v = datos.variantes[i];
      if (soloDisponibles && !v.disponible) continue;
      if (casa(v, vals)) return v;
    }
    return null;
  }

  function aplicarSeleccion(ambito, vals) {
    gruposDe(ambito).forEach(function (g) {
      var i = Number(g.getAttribute('data-indice'));
      $$('.talla', g).forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-valor') === vals[i] ? 'true' : 'false');
      });
      var eco = g.querySelector('[data-opcion-elegida]');
      if (eco) eco.textContent = vals[i] || '—';
    });
  }

  /* Tacha los valores que no llevan a nada disponible con lo ya elegido en las
     otras filas. No los bloquea: al pulsarlos se reajustan las demás opciones. */
  function refrescarDisponibles(ambito, datos) {
    var vals = seleccionDe(ambito);
    var varias = gruposDe(ambito).length > 1;
    if (!varias) return;
    gruposDe(ambito).forEach(function (g) {
      var i = Number(g.getAttribute('data-indice'));
      $$('.talla', g).forEach(function (b) {
        var prueba = vals.slice();
        prueba[i] = b.getAttribute('data-valor');
        var hay = !!buscarVariante(datos, prueba, true);
        b.classList.toggle('talla--agotada', !hay);
      });
    });
  }

  document.addEventListener('click', function (e) {
    var pill = e.target.closest('.talla');
    if (!pill || pill.disabled) return;
    var grupo = pill.closest('[data-grupo-opcion]');
    var ambito = pill.closest('[data-ficha]') || pill.closest('[data-hoja-tallas]');
    if (!grupo || !ambito) return;

    var datos = datosDe(ambito.parentNode) || datosDe(ambito) || datosDe(document);
    var i = Number(grupo.getAttribute('data-indice'));
    var vals = seleccionDe(ambito);
    vals[i] = pill.getAttribute('data-valor');

    /* Si la combinación resultante no existe o está agotada, se salta a la
       primera disponible que conserve el valor recién pulsado. */
    var v = buscarVariante(datos, vals, true);
    if (!v) {
      var libre = [];
      libre[i] = vals[i];
      v = buscarVariante(datos, libre, true) || buscarVariante(datos, libre, false);
    }
    if (v && v.opciones) vals = v.opciones.slice();

    aplicarSeleccion(ambito, vals);
    if (datos) refrescarDisponibles(ambito, datos);
    if (!v) v = buscarVariante(datos, vals, false);
    if (v) pintarVariante(ambito, v);
  });

  document.addEventListener('click', function (e) {
    var boton = e.target.closest('[data-agregar]');
    if (!boton) return;
    e.preventDefault();
    agregarAlCarrito(boton.getAttribute('data-variante'), 1, boton);
  });

  /* ---------------------------------------------------------
     5. Galería de la ficha
     --------------------------------------------------------- */
  /* La galería es un carrusel con scroll-snap: se pasa con el dedo en móvil
     y con los puntos o las miniaturas en cualquier tamaño. */
  function marcarGaleria(galeria, i) {
    $$('[data-thumb], [data-punto]', galeria).forEach(function (n) {
      var lista = n.parentNode.children;
      var k = Array.prototype.indexOf.call(lista, n);
      if (k === i) n.setAttribute('aria-current', 'true'); else n.removeAttribute('aria-current');
    });
  }

  function irASlide(galeria, i) {
    var slider = galeria.querySelector('[data-slider]');
    if (!slider) return;
    var x = i * slider.clientWidth;
    if (slider.scrollTo) slider.scrollTo({ left: x, behavior: 'smooth' });
    else slider.scrollLeft = x;
    marcarGaleria(galeria, i);
  }

  document.addEventListener('click', function (e) {
    var boton = e.target.closest('[data-thumb], [data-punto]');
    if (!boton) return;
    var galeria = boton.closest('[data-galeria]');
    if (!galeria) return;
    irASlide(galeria, Array.prototype.indexOf.call(boton.parentNode.children, boton));
  });

  /* El scroll no burbujea: se escucha en fase de captura para cubrir también
     las fichas que llegan por Section Rendering API. */
  var galeriaEnCurso = false;
  document.addEventListener('scroll', function (e) {
    var slider = e.target;
    if (!slider || slider.nodeType !== 1 || !slider.hasAttribute('data-slider')) return;
    if (galeriaEnCurso) return;
    galeriaEnCurso = true;
    requestAnimationFrame(function () {
      galeriaEnCurso = false;
      var galeria = slider.closest('[data-galeria]');
      var ancho = slider.clientWidth;
      if (!galeria || !ancho) return;
      marcarGaleria(galeria, Math.round(slider.scrollLeft / ancho));
    });
  }, true);

  /* ---------------------------------------------------------
     5b. Visor a pantalla completa
     --------------------------------------------------------- */
  /* Al tocar una foto de la ficha se abre a pantalla completa. Se pasa con el
     dedo, las flechas o el teclado. Se sale con el botón Cerrar, tocando fuera
     de la foto, deslizando hacia abajo, con Escape o con "atrás". */
  var visor = null, visorGaleria = null, visorFoco = null, saltarPop = false;
  var ICONO_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var ICONO_FLECHA = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';

  function visorIndice() {
    var s = visor.querySelector('[data-visor-slider]');
    return s.clientWidth ? Math.round(s.scrollLeft / s.clientWidth) : 0;
  }

  function visorPintar() {
    if (!visor) return;
    var total = $$('.visor__slide', visor).length, i = visorIndice();
    visor.querySelector('[data-visor-cuenta]').textContent = (i + 1) + ' / ' + total;
    visor.querySelector('[data-visor-ant]').disabled = i <= 0;
    visor.querySelector('[data-visor-sig]').disabled = i >= total - 1;
  }

  function visorIr(i, suave) {
    var s = visor.querySelector('[data-visor-slider]');
    var total = $$('.visor__slide', visor).length;
    i = Math.max(0, Math.min(total - 1, i));
    var x = i * s.clientWidth;
    if (suave && s.scrollTo) s.scrollTo({ left: x, behavior: 'smooth' });
    else s.scrollLeft = x;
  }

  function abrirVisor(galeria, indice) {
    var fotos = $$('[data-foto]', galeria);
    if (!fotos.length || visor) return;
    var T = C.textos || {};
    visorGaleria = galeria;
    visorFoco = document.activeElement;
    visor = document.createElement('div');
    visor.className = 'visor';
    visor.setAttribute('role', 'dialog');
    visor.setAttribute('aria-modal', 'true');
    visor.innerHTML =
      '<div class="visor__slider" data-visor-slider></div>' +
      '<button type="button" class="visor__cerrar" data-visor-cerrar>' + ICONO_X + '<span></span></button>' +
      '<button type="button" class="visor__nav visor__nav--ant" data-visor-ant>' + ICONO_FLECHA + '</button>' +
      '<button type="button" class="visor__nav visor__nav--sig" data-visor-sig>' + ICONO_FLECHA + '</button>' +
      '<span class="visor__cuenta" data-visor-cuenta></span>';
    visor.querySelector('[data-visor-cerrar] span').textContent = T.cerrar || 'Cerrar';
    visor.querySelector('[data-visor-ant]').setAttribute('aria-label', T.anterior || 'Anterior');
    visor.querySelector('[data-visor-sig]').setAttribute('aria-label', T.siguiente || 'Siguiente');
    var slider = visor.querySelector('[data-visor-slider]');
    fotos.forEach(function (f) {
      var slide = document.createElement('div');
      slide.className = 'visor__slide';
      var img = document.createElement('img');
      var src = f.currentSrc || f.src;
      img.src = src.replace(/([?&]width=)\d+/, '$11600');
      img.alt = f.alt;
      img.draggable = false;
      slide.appendChild(img);
      slider.appendChild(slide);
    });
    if (fotos.length < 2) visor.classList.add('visor--una');
    document.body.appendChild(visor);
    visorIr(indice, false);
    visorPintar();
    slider.addEventListener('scroll', function () { requestAnimationFrame(visorPintar); });
    try { visor.querySelector('[data-visor-cerrar]').focus({ preventScroll: true }); } catch (e) {}

    /* "Atrás" del teléfono cierra solo el visor, no la ficha. */
    var estado = { costaVisor: true };
    if (history.state && history.state.costaFicha) estado.costaFicha = history.state.costaFicha;
    history.pushState(estado, '', window.location.href);
  }

  function cerrarVisor(opts) {
    if (!visor) return;
    opts = opts || {};
    /* La ficha queda en la misma foto que se estaba viendo. */
    var i = visorIndice();
    var s = visorGaleria && visorGaleria.querySelector('[data-slider]');
    if (s) { s.style.scrollBehavior = 'auto'; s.scrollLeft = i * s.clientWidth; s.style.scrollBehavior = ''; marcarGaleria(visorGaleria, i); }
    visor.parentNode.removeChild(visor);
    visor = null; visorGaleria = null;
    if (visorFoco) { try { visorFoco.focus({ preventScroll: true }); } catch (e) {} }
    if (!opts.desdeHistorial && history.state && history.state.costaVisor) { saltarPop = true; history.back(); }
  }

  document.addEventListener('click', function (e) {
    if (visor) {
      if (!visor.contains(e.target)) return;
      if (e.target.closest('[data-visor-ant]')) { visorIr(visorIndice() - 1, true); return; }
      if (e.target.closest('[data-visor-sig]')) { visorIr(visorIndice() + 1, true); return; }
      if (e.target.closest('[data-visor-cerrar]') || e.target.tagName !== 'IMG') cerrarVisor();
      return;
    }
    var foto = e.target.closest('[data-foto]');
    if (!foto) return;
    var galeria = foto.closest('[data-galeria]');
    if (!galeria) return;
    abrirVisor(galeria, $$('[data-foto]', galeria).indexOf(foto));
  });

  /* En captura: con el visor abierto, Escape no debe cerrar también la ficha. */
  document.addEventListener('keydown', function (e) {
    if (!visor) return;
    if (e.key === 'Escape') { e.preventDefault(); cerrarVisor(); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); visorIr(visorIndice() - 1, true); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); visorIr(visorIndice() + 1, true); }
    else if (e.key === 'Tab') {
      var foco = $$('button:not([disabled])', visor).filter(function (n) { return n.offsetParent !== null; });
      var k = foco.indexOf(document.activeElement) + (e.shiftKey ? -1 : 1);
      e.preventDefault();
      if (foco.length) foco[(k + foco.length) % foco.length].focus();
    }
    e.stopPropagation();
  }, true);

  /* Deslizar hacia abajo cierra el visor. */
  var toqueVisor = null;
  document.addEventListener('touchstart', function (e) {
    toqueVisor = (visor && e.touches.length === 1) ? { x: e.touches[0].clientX, y: e.touches[0].clientY } : null;
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (!visor || !toqueVisor || !e.changedTouches.length) return;
    var dx = e.changedTouches[0].clientX - toqueVisor.x;
    var dy = e.changedTouches[0].clientY - toqueVisor.y;
    toqueVisor = null;
    if (dy > 80 && dy > Math.abs(dx) * 1.5) cerrarVisor();
  }, { passive: true });

  /* ---------------------------------------------------------
     6. Ficha en modal  —  no existe página de producto
     --------------------------------------------------------- */
  var urlBase = window.location.pathname + window.location.search;
  var fichaAbiertaDesdeCarga = false;

  function destinoFicha() {
    return ESCRITORIO()
      ? { capa: 'ficha-d', nodo: $('[data-ficha-destino-d]') }
      : { capa: 'ficha-m', nodo: $('[data-ficha-destino-m]') };
  }

  function pedirSeccion(url, seccion) {
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    return fetch(url + sep + 'section_id=' + seccion, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { if (!r.ok) throw new Error('seccion'); return r.text(); });
  }

  /* Preselecciona la primera talla disponible y pinta precio/CTA/stock */
  function inicializarFicha(nodo) {
    var contenedor = nodo.querySelector('[data-ficha]') || nodo.querySelector('[data-hoja-tallas]');
    if (!contenedor) return;
    var datos = datosDe(nodo);
    if (!datos || !datos.variantes || datos.variantes.length < 2) return;
    var primera = datos.variantes.filter(function (v) { return v.disponible; })[0];
    if (!primera) return;
    aplicarSeleccion(contenedor, (primera.opciones || []).slice());
    refrescarDisponibles(contenedor, datos);
    pintarVariante(contenedor, primera);
  }

  function abrirFicha(url, opciones) {
    opciones = opciones || {};
    var d = destinoFicha();
    if (!d.nodo) return;
    return pedirSeccion(url, 'ficha-modal')
      .then(function (html) {
        d.nodo.innerHTML = html;
        abrirCapa(d.capa);
        inicializarFicha(d.nodo);
        if (!opciones.sinHistorial) history.pushState({ costaFicha: url }, '', url);
      })
      .catch(function () { window.location.href = url; });
  }

  function restaurarUrl() {
    if (fichaAbiertaDesdeCarga) {
      history.replaceState({}, '', urlBase);
      fichaAbiertaDesdeCarga = false;
      return;
    }
    if (history.state && history.state.costaFicha) history.back();
  }

  document.addEventListener('click', function (e) {
    var enlace = e.target.closest('[data-abrir-ficha]');
    if (!enlace) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    e.preventDefault();
    var card = enlace.closest('[data-card]');
    var url = enlace.getAttribute('href') || (card && card.getAttribute('data-producto-url'));
    if (url) abrirFicha(url);
  });

  window.addEventListener('popstate', function (e) {
    var estado = e.state || {};
    if (saltarPop) { saltarPop = false; return; }
    if (visor) { cerrarVisor({ desdeHistorial: true }); return; }
    if (estado.costaVisor && !estado.costaFicha) return;
    if (estado.costaFicha) {
      abrirFicha(estado.costaFicha, { sinHistorial: true });
    } else if (capaActiva && capaActiva.getAttribute('data-capa').indexOf('ficha') === 0) {
      cerrarCapa({ desdeHistorial: true });
    }
  });

  /* ---------------------------------------------------------
     7. Hoja de tallas (camino corto desde la ficha)
     --------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var boton = e.target.closest('[data-accion="tallas"]');
    if (!boton) return;
    e.preventDefault();
    var handle = boton.getAttribute('data-handle');
    var destino = $('[data-tallas-destino]');
    if (!destino) return;
    boton.setAttribute('aria-busy', 'true');
    pedirSeccion('/products/' + handle, 'hoja-tallas')
      .then(function (html) {
        destino.innerHTML = html;
        abrirCapa('tallas');
        inicializarFicha(destino);
      })
      .catch(function () { avisar(C.textos.error, true); })
      .then(function () { boton.removeAttribute('aria-busy'); });
  });

  document.addEventListener('click', function (e) {
    var boton = e.target.closest('[data-accion="agregar"]');
    if (!boton) return;
    e.preventDefault();
    agregarAlCarrito(boton.getAttribute('data-variante'), 1, boton);
  });

  /* ---------------------------------------------------------
     8. Entrada directa a /products/handle
     --------------------------------------------------------- */
  function montarFichaInicial() {
    var semilla = $('[data-ficha-inicial]');
    if (!semilla) return;
    var url = semilla.getAttribute('data-ficha-inicial');
    urlBase = semilla.getAttribute('data-volver') || '/';
    fichaAbiertaDesdeCarga = true;

    /* La ficha ya vino renderizada del servidor: la movemos, no la volvemos a pedir. */
    var ssr = $('[data-ficha-ssr]');
    var caja = ssr && ssr.querySelector('.ficha-ssr__caja');
    var d = destinoFicha();
    if (caja && d.nodo) {
      d.nodo.innerHTML = caja.innerHTML;
      ssr.parentNode.removeChild(ssr);
      abrirCapa(d.capa);
      inicializarFicha(d.nodo);
      return;
    }
    abrirFicha(url, { sinHistorial: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', montarFichaInicial);
  } else {
    montarFichaInicial();
  }


  /* ---------------------------------------------------------
     9. Carrusel de portada
     La pista es un scroll con snap: el deslizar con el dedo lo resuelve el
     navegador, y aquí solo se lee en qué slide quedó para pintar las barras.
     Sin JS el carrusel sigue funcionando como scroll horizontal.
     --------------------------------------------------------- */
  function montarSlider(raiz) {
    var pista = raiz.querySelector('[data-slider-pista]');
    if (!pista) return;
    var slides = $$('[data-slide]', raiz);
    var barras = $$('[data-slider-ir]', raiz);
    if (slides.length < 2) return;

    var actual = 0;
    var temporizador = null;
    var quietoHasta = 0;
    var autoplay = raiz.getAttribute('data-autoplay') === 'true';
    var intervalo = parseInt(raiz.getAttribute('data-intervalo'), 10) || 6000;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function pintar(i) {
      if (i === actual) return;
      actual = i;
      slides.forEach(function (s, n) {
        var visible = n === i;
        if (visible) s.removeAttribute('aria-hidden');
        else s.setAttribute('aria-hidden', 'true');
        var cta = s.querySelector('.hero-slide__cta');
        if (cta) {
          if (visible) cta.removeAttribute('tabindex');
          else cta.setAttribute('tabindex', '-1');
        }
      });
      barras.forEach(function (b, n) {
        if (n === i) b.setAttribute('aria-current', 'true');
        else b.removeAttribute('aria-current');
      });
    }

    function ir(i, manual) {
      var destino = slides[i];
      if (!destino) return;
      if (manual) quietoHasta = Date.now() + intervalo * 2;
      var x = destino.offsetLeft - pista.offsetLeft;
      pista.scrollTo({ left: x, behavior: reduce ? 'auto' : 'smooth' });
      /* Red de seguridad: si el navegador ignora el desplazamiento suave, el
         carrusel se quedaría clavado. Se comprueba y, si no se movió, se salta
         de golpe: mejor sin animación que sin carrusel. */
      window.setTimeout(function () {
        if (Math.abs(pista.scrollLeft - x) > 2) pista.scrollLeft = x;
      }, 400);
      pintar(i);
    }

    /* La barra activa se decide por la posición real del scroll, no por lo que
       creemos haber pedido: así el deslizar con el dedo también la actualiza. */
    var pendiente = null;
    pista.addEventListener('scroll', function () {
      if (pendiente) return;
      pendiente = window.requestAnimationFrame(function () {
        pendiente = null;
        var ancho = pista.clientWidth || 1;
        var i = Math.round(pista.scrollLeft / ancho);
        if (i < 0) i = 0;
        if (i > slides.length - 1) i = slides.length - 1;
        pintar(i);
      });
    }, { passive: true });

    barras.forEach(function (b) {
      b.addEventListener('click', function () {
        ir(parseInt(b.getAttribute('data-slider-ir'), 10), true);
      });
    });

    raiz.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); ir(Math.min(actual + 1, slides.length - 1), true); }
      if (e.key === 'ArrowLeft')  { e.preventDefault(); ir(Math.max(actual - 1, 0), true); }
    });

    if (!autoplay || reduce) return;

    /* El paso automático se detiene mientras la clienta está mirando o tocando,
       y no avanza si la portada no está en pantalla. */
    function avanzar() {
      if (document.hidden) return;
      /* Si la pista está oculta —escritorio con el video encendido— no tiene
         sentido seguir pasando slides que nadie ve. offsetParent es null
         cuando el elemento está en display:none, así que esto también se
         ajusta solo al cambiar el tamaño de la ventana. */
      if (!pista.offsetParent) return;
      if (Date.now() < quietoHasta) return;
      if (raiz.matches(':hover')) return;
      var r = raiz.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      ir((actual + 1) % slides.length);
    }

    temporizador = window.setInterval(avanzar, intervalo);

    ['pointerdown', 'touchstart', 'focusin'].forEach(function (ev) {
      raiz.addEventListener(ev, function () { quietoHasta = Date.now() + intervalo * 2; }, { passive: true });
    });

    window.addEventListener('pagehide', function () { window.clearInterval(temporizador); });
  }

  $$('[data-slider]').forEach(montarSlider);

  /* ---------------------------------------------------------
     9b. Portada de escritorio: imagen o video
     El <video> / <img> llega del servidor sin src: aquí se decide si
     ponérselo. En celular no se le pone nunca, así que el archivo no se
     descarga y la portada del móvil sigue costando lo mismo que antes. Si el
     archivo no carga, se quita la clase y vuelve el carrusel.
     --------------------------------------------------------- */
  function montarHeroEscritorio(raiz) {
    var tipo = raiz.getAttribute('data-hero-d');
    var src = raiz.getAttribute('data-hero-d-src');
    var media = raiz.querySelector('[data-hero-d-media]');
    if (!tipo || !src || !media) return;

    var esVideo = tipo === 'video';
    var poster = raiz.getAttribute('data-hero-d-poster');
    var srcset = raiz.getAttribute('data-hero-d-srcset');
    var escritorio = window.matchMedia('(min-width: 990px)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var puesto = false;

    function reproducir() {
      if (!esVideo || !media.getAttribute('src')) return;
      var p = media.play();
      if (p && p.catch) p.catch(function () { /* el navegador lo bloqueó; queda el poster */ });
    }

    function encender() {
      if (puesto) return;
      puesto = true;

      if (!esVideo) {
        if (srcset) {
          media.setAttribute('srcset', srcset);
          media.setAttribute('sizes', '100vw');
        }
        media.setAttribute('src', src);
        /* Es lo primero que se ve de la página: que el navegador la pida ya. */
        media.setAttribute('fetchpriority', 'high');
        return;
      }

      if (poster) media.setAttribute('poster', poster);
      /* Con movimiento reducido se deja solo el poster: el <video> sin src
         pinta su poster y se queda quieto, que es justo lo que se pide. */
      if (reduce.matches) return;
      media.setAttribute('src', src);
      media.load();
      reproducir();
    }

    media.addEventListener('error', function () {
      raiz.classList.remove('hero-slider--d');
    });

    function revisar() {
      if (escritorio.matches) {
        raiz.classList.add('hero-slider--d');
        encender();
      } else {
        raiz.classList.remove('hero-slider--d');
        if (esVideo && !media.paused) media.pause();
      }
    }

    if (escritorio.addEventListener) escritorio.addEventListener('change', revisar);
    else if (escritorio.addListener) escritorio.addListener(revisar);
    revisar();

    /* De aquí para abajo solo aplica al video: una imagen no se pausa.
       Fuera de pantalla o con la pestaña en segundo plano no se reproduce:
       no se gana nada y se gasta batería. */
    if (!esVideo) return;

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (!media.getAttribute('src')) return;
          if (e.isIntersecting && escritorio.matches && !document.hidden) reproducir();
          else if (!media.paused) media.pause();
        });
      }, { threshold: 0.1 }).observe(raiz);
    }

    document.addEventListener('visibilitychange', function () {
      if (!media.getAttribute('src')) return;
      if (document.hidden) { if (!media.paused) media.pause(); }
      else if (escritorio.matches) reproducir();
    });
  }

  $$('[data-hero-d]').forEach(montarHeroEscritorio);

  /* =======================================================
     BUSCADOR CON RESULTADOS EN VIVO
     Pide la sección 'busqueda-predictiva' a /search/suggest y la inyecta.
     El formulario sigue siendo un form normal: sin JS, Enter busca igual.
     ======================================================= */
  var RUTA_SUGERENCIAS = (window.Costa.rutas.buscar || '/search') + '/suggest';
  var MINIMO_LETRAS = 2;

  function montarBuscador(caja) {
    var input = caja.querySelector('[data-buscador-input]');
    var panel = caja.querySelector('[data-buscador-panel]');
    var limpiar = caja.querySelector('[data-buscador-limpiar]');
    if (!input || !panel) return;

    var temporizador = null;
    var peticion = null;

    function cerrar() {
      panel.hidden = true;
      panel.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
      caja.removeAttribute('data-cargando');
    }

    function opciones() {
      return Array.prototype.slice.call(panel.querySelectorAll('[data-buscador-opcion]'));
    }

    function mover(paso) {
      var lista = opciones();
      if (!lista.length) return;
      var actual = lista.findIndex(function (o) { return o.hasAttribute('data-activo'); });
      var siguiente = actual + paso;
      if (siguiente < 0) siguiente = lista.length - 1;
      if (siguiente >= lista.length) siguiente = 0;
      lista.forEach(function (o) { o.removeAttribute('data-activo'); });
      lista[siguiente].setAttribute('data-activo', '');
      lista[siguiente].scrollIntoView({ block: 'nearest' });
    }

    function buscar(termino) {
      if (peticion) peticion.abort();
      peticion = new AbortController();
      caja.setAttribute('data-cargando', '');

      var url = RUTA_SUGERENCIAS +
        '?q=' + encodeURIComponent(termino) +
        '&section_id=busqueda-predictiva' +
        '&resources[type]=product,collection' +
        '&resources[limit]=6&resources[options][unavailable_products]=last';

      fetch(url, { signal: peticion.signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { if (!r.ok) throw new Error('sugerencias'); return r.text(); })
        .then(function (html) {
          caja.removeAttribute('data-cargando');
          // La respuesta viene envuelta en el div de la sección; solo interesa el interior.
          var envoltorio = document.createElement('div');
          envoltorio.innerHTML = html;
          var contenido = envoltorio.querySelector('.bp');
          if (!contenido) { cerrar(); return; }
          panel.innerHTML = '';
          panel.appendChild(contenido);
          panel.hidden = false;
          input.setAttribute('aria-expanded', 'true');
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          caja.removeAttribute('data-cargando');
          cerrar();
        });
    }

    input.addEventListener('input', function () {
      var termino = input.value.trim();
      if (limpiar) limpiar.hidden = termino.length === 0;
      clearTimeout(temporizador);
      if (termino.length < MINIMO_LETRAS) { cerrar(); return; }
      temporizador = setTimeout(function () { buscar(termino); }, 220);
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= MINIMO_LETRAS && panel.innerHTML) {
        panel.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { cerrar(); input.blur(); return; }
      if (panel.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); mover(1); return; }
      if (e.key === 'ArrowUp') { e.preventDefault(); mover(-1); return; }
      if (e.key === 'Enter') {
        var activo = panel.querySelector('[data-buscador-opcion][data-activo]');
        if (activo) { e.preventDefault(); activo.click(); }
      }
    });

    if (limpiar) {
      limpiar.addEventListener('click', function () {
        input.value = '';
        limpiar.hidden = true;
        cerrar();
        input.focus();
      });
    }

    panel.addEventListener('click', function (e) {
      if (e.target.closest('[data-buscador-opcion]')) cerrar();
    });

    document.addEventListener('click', function (e) {
      if (!caja.contains(e.target)) cerrar();
    });
  }

  $$('[data-buscador]').forEach(montarBuscador);

  /* Al cambiar de tamaño, mover la ficha abierta al contenedor correcto */
  var anchoPrevio = window.innerWidth;
  window.addEventListener('resize', function () {
    if (!capaActiva) { anchoPrevio = window.innerWidth; return; }
    var nombre = capaActiva.getAttribute('data-capa');
    if (nombre.indexOf('ficha') !== 0) return;
    var cruzo = (anchoPrevio < 990) !== (window.innerWidth < 990);
    anchoPrevio = window.innerWidth;
    if (!cruzo) return;
    var actual = capaActiva.querySelector('[data-ficha]');
    if (!actual) return;
    var url = actual.getAttribute('data-url');
    cerrarCapa({ silencioso: true });
    abrirFicha(url, { sinHistorial: true });
  });
})();
